(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gc-adopt"] && !Shopify.designMode) return;
  try {
    
function initializeClubCards(root=document){
  root.querySelectorAll('.gc-adopt__cards').forEach(row=>{
    if(row.dataset.clubInitialized)return;
    row.dataset.clubInitialized='true';
    const dots=row.parentElement.querySelectorAll('.gc-adopt__dots i');
    row.addEventListener('scroll',()=>{
      const card=row.querySelector('.gc-adopt__card');if(!card)return;
      const step=card.getBoundingClientRect().width+12;
      const active=row.scrollLeft>=row.scrollWidth-row.clientWidth-4?dots.length-1:Math.round(row.scrollLeft/step);
      dots.forEach((dot,index)=>dot.classList.toggle('is-active',index===active));
    },{passive:true});
  });
}
document.addEventListener('DOMContentLoaded',()=>initializeClubCards());
document.addEventListener('shopify:section:load',event=>initializeClubCards(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-products"] && !Shopify.designMode) return;
  try {
    
function initializeClubCarousels(root=document){
  root.querySelectorAll('[data-gc-carousel]').forEach(carousel=>{
    if(carousel.dataset.initialized)return;carousel.dataset.initialized='true';
    const row=carousel.querySelector('.gc-related__grid');const prev=carousel.querySelector('[data-gc-prev]');const next=carousel.querySelector('[data-gc-next]');
    if(!row||!prev||!next)return;
    const update=()=>{prev.disabled=row.scrollLeft<2;next.disabled=row.scrollLeft+row.clientWidth>=row.scrollWidth-2;};
    const scroll=direction=>{const card=row.querySelector('.gc-related__item');const gap=parseFloat(getComputedStyle(row).columnGap)||16;row.scrollBy({left:direction*((card?.getBoundingClientRect().width||240)+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
    prev.addEventListener('click',()=>scroll(-1));next.addEventListener('click',()=>scroll(1));row.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(row);update();
  });
}
document.addEventListener('DOMContentLoaded',()=>initializeClubCarousels());document.addEventListener('shopify:section:load',event=>initializeClubCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-sticky-cart"]) return;
  try {
    
function initializeClubSticky(){
  const root=document.querySelector('[data-club-sticky]');
  const form=document.querySelector('product-form form[action*="/cart/add"]');
  const buy=form?.querySelector('[type="submit"]');
  if(!root||!form||!buy||root.dataset.initialized)return;
  root.dataset.initialized='true';
  const stickyButton=root.querySelector('[data-club-sticky-submit]');
  const syncButton=()=>{const current=document.querySelector('product-form form[action*="/cart/add"] [type="submit"]');if(!current)return;stickyButton.disabled=current.disabled;stickyButton.textContent=(current.querySelector('span')?.textContent||current.textContent).trim();};
  syncButton();
  const observer=new IntersectionObserver(entries=>{const show=!entries[0].isIntersecting&&entries[0].boundingClientRect.top<0;root.hidden=!show;root.classList.toggle('is-shown',show);root.setAttribute('aria-hidden',String(!show));},{threshold:0});
  observer.observe(buy);
  stickyButton.addEventListener('click',()=>{const current=document.querySelector('product-form form[action*="/cart/add"]');const submit=current?.querySelector('[type="submit"]');if(submit&&!submit.disabled)current.requestSubmit(submit);});
  const info=form.closest('product-info');
  if(info)new MutationObserver(()=>{
    const price=info.querySelector('.price__sale .price-item--sale')||info.querySelector('.price__regular .price-item--regular');
    if(price)root.querySelector('[data-club-sticky-price]').textContent=price.textContent.trim();
    syncButton();
  }).observe(info,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
  const drawer=document.querySelector('cart-drawer');
  if(drawer)new MutationObserver(()=>root.classList.toggle('is-cart-open',drawer.classList.contains('active'))).observe(drawer,{attributes:true,attributeFilter:['class']});
}
document.addEventListener('DOMContentLoaded',initializeClubSticky);
document.addEventListener('shopify:section:load',initializeClubSticky);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
